import React, { createContext, useContext, useState } from 'react';

import CallInProgressModal from '../CRM/components/CallInProgressModal';

interface CallInProgressContextType {
  isCallInProgressModalOpen: boolean;
  setIsCallInProgressModalOpen: (isOpen: boolean) => void;
  showCallInProgressModal: () => void;
}

const CallInProgressContext = createContext<
  CallInProgressContextType | undefined
>(undefined);

export const CallInProgressProvider: React.FC<{
  children: React.ReactNode;
}> = ({ children }) => {
  const [isCallInProgressModalOpen, setIsCallInProgressModalOpen] =
    useState(false);

  const showCallInProgressModal = () => {
    setIsCallInProgressModalOpen(true);
  };

  return (
    <CallInProgressContext.Provider
      value={{
        isCallInProgressModalOpen,
        setIsCallInProgressModalOpen,
        showCallInProgressModal,
      }}
    >
      {children}
      <CallInProgressModal
        isCallInProgressModalOpen={isCallInProgressModalOpen}
        setIsCallInProgressModalOpen={setIsCallInProgressModalOpen}
      />
    </CallInProgressContext.Provider>
  );
};

export const useCallInProgress = (): CallInProgressContextType => {
  const context = useContext(CallInProgressContext);
  if (context === undefined) {
    throw new Error(
      'useCallInProgress must be used within a CallInProgressProvider'
    );
  }
  return context;
};
